import { Component } from '@angular/core';
import { Router, ActivationEnd, RouterEvent } from '@angular/router';
import { MediaObserver, MediaChange } from '@angular/flex-layout';

import { environment } from '../../../environments/environment';
import { ErrorHandler, HandleError } from '../../services/error-handler.service';
import { NavigationService } from '../../services/navigation.service';
import { UserService } from '../../services/user.service';
import { CompanyService } from '../../services/company.service';

import { NavigationOptions } from '../../models/navigation';
import { CompanyList, CompanyInformation } from '../../models/company';

@Component({
  selector: 'app-page-footer',
  templateUrl: './page-footer.component.html',
  styleUrls: ['./page-footer.component.scss']
})
export class PageFooterComponent {
  private _handleError: HandleError;
  private _logging = environment.logging;
  private _companyCodeSettings = environment.companyCode;

  isBrowserIE = /msie\s|trident\//i.test(window.navigator.userAgent);

  appInfo = environment.appInfo;
  appUrls = environment.appUrls;

  currentDate: Date = new Date();

  navigationOptions: NavigationOptions;

  companyInformation: CompanyInformation;
  companyList: CompanyList[];

  constructor(
    private _router: Router,
    private _errorHandler: ErrorHandler,
    private _navigationService: NavigationService,
    private _userService: UserService,
    private _companyService: CompanyService,
    public media: MediaObserver
  ) {
    this._handleError = _errorHandler.createHandleError('PageFooterComponent');

    this.companyList = this._companyCodeSettings.companyList;

    this.navigationOptions = _navigationService.getNewNavigationOptions();

    // Cannot use ActivatedRoute.data.subscribe() because the page header is outside the <router-outlet>
    // Must use Router.events.subscribe() instead
    this._router.events.subscribe((e: RouterEvent) => {
      if (e instanceof ActivationEnd) {
        if (e.snapshot.routeConfig !== undefined && e.snapshot.routeConfig !== null && e.snapshot.routeConfig.path !== undefined) {
          this.navigationOptions = this._navigationService.getNavigationOptionsForPath(e.snapshot.routeConfig.path);
        } else {
          this.navigationOptions = this._navigationService.getNewNavigationOptions();
        }
      }
    });

    this.companyInformation = this._companyService.getNewCompanyInformation();

    this._companyService.companyInformation.subscribe(
      response => (this.companyInformation = response),
      error => this._handleError('companyInformation.subscribe', error)
    );
  }

  manualCompanyCodeChangeEnabled(): boolean {
    return this._companyCodeSettings.allowManualCompanyCodeChange && this._router.url.replace('/', '') === '';
  }

  selectManualCompany(companyCode: string): void {
    if (companyCode !== null && companyCode.length > 0) {
      this._companyService.setManualCompanyCode(companyCode);

      this._userService.logout();

      if (this._logging.navigationTraceLog) {
        console.log('PageFooterComponent.setManualCompany');
      }
      this._router.navigate(['login']);
    }
  }

  selectManualCompanyEnabled(companyCode: string): boolean {
    return companyCode !== null && companyCode.length > 0 ? companyCode !== this._companyService.getCompanyCode() : false;
  }

  private _onCompanyInformationChanged(newCompanyInformation: CompanyInformation): void {
    this.companyInformation = newCompanyInformation;
  }
}
